import secondaryComponents from "../..";
import Images from "../../../../assets/images";
import { useCustomersTable } from "./useCustomersTable";

export const CustomersTable = ({
  customers,
  isViaSellMode = false,
  metaDetails,
  gotoPage,
}) => {
  const {
    instance,
    isCustomerDeleteProperties,
    setIsCustomerDeleteProperties,
  } = useCustomersTable({ customers, isViaSellMode });
  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
    instance;

  return (
    <div>
      <secondaryComponents.TableHelper
        getTableProps={getTableProps}
        getTableBodyProps={getTableBodyProps}
        headerGroups={headerGroups}
        rows={rows}
        prepareRow={prepareRow}
        hasAction={true}
      >
        <div className="text-center my-5">
          <img
            src={Images.customersEmptyState}
            alt="No Customers Found"
            width="250px"
            height="262px"
          />
          <h4>No data available</h4>
        </div>
      </secondaryComponents.TableHelper>

      {/* delete modal */}
      <secondaryComponents.Modal
        isActive={isCustomerDeleteProperties !== null}
        closeModal={() => setIsCustomerDeleteProperties(null)}
        width={500}
      >
        <secondaryComponents.CustomerDeletion
          closeWidget={() => setIsCustomerDeleteProperties(null)}
          customerDetails={isCustomerDeleteProperties}
        />
      </secondaryComponents.Modal>

      {/* show pagination component only when data is available */}
      {customers?.length > 0 && (
        <secondaryComponents.Pagination
          totalPageNumber={metaDetails.last_page}
          handlePageClick={(value) => gotoPage(value?.selected + 1)}
          currentPage={metaDetails.current_page}
        />
      )}
    </div>
  );
};

export default CustomersTable;
